import React from 'react';
import { theme } from '../styles/theme';
import { TYPE_FILTERS } from './events';

// Selettore Tutti / Pubblici / Privati per le liste eventi
// `right`: contenuto opzionale allineato a destra (es. totale iscritti)
function TypeFilter({ value, onChange, right }) {
  return (
    <div style={styles.row} role="tablist" aria-label="Filtra per tipologia">
      {TYPE_FILTERS.map((f) => (
        <button
          key={f.value}
          type="button"
          role="tab"
          aria-selected={value === f.value}
          onClick={() => onChange(f.value)}
          style={value === f.value ? styles.active : styles.button}
        >
          {f.label}
        </button>
      ))}
      {right}
    </div>
  );
}

const base = {
  padding: '6px 14px',
  borderRadius: '16px',
  fontSize: '13px',
  cursor: 'pointer',
  border: `1px solid ${theme.colors.border}`,
};

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    maxWidth: '500px',
    marginBottom: '10px',
  },
  button: {
    ...base,
    backgroundColor: theme.colors.white,
    color: theme.colors.text,
  },
  active: {
    ...base,
    backgroundColor: theme.colors.brand,
    borderColor: theme.colors.brand,
    color: theme.colors.white,
    fontWeight: 'bold',
  },
};

export default TypeFilter;
